import { LOBState } from "stores/wizard/state";
import { ThirdPartyPackageConfig } from "stores/wizard/config";

export class ThirdPartyPackageWizardState implements Pick<LOBState, "config"> {
  public config: ThirdPartyPackageConfig;

  constructor(config: ThirdPartyPackageConfig) {
    this.config = config;
  }
}
